import React from 'react';

function Error() {
  const data = window._THULEDATA._Withdrawals;
  return (
    <div className="col-md-8 col-lg-6 offset-md-2 offset-lg-3 mb-14">
      <h1 className="heading6 mb-7">{data.LoginToCreateWithdrawal}</h1>
      {data.LoginUrl && data.Login && (
        <a href={data.LoginUrl} className="btn thule-btn-default login-btn">
          {data.Login}
        </a>
      )}
    </div>
  );
}

export default Error;
